import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { makeWidthFlexible, VennChart } from "@unifiedpatents/euclid-react";
import { withChartConfig } from "../../common/chart-config-hoc";
import { getDocumentsWithAggregations } from "../../../services/api-landscape";

class VennDiagram extends Component {
  static propTypes = {
    size: PropTypes.number.isRequired,
    filter: PropTypes.object,
    defaultSets: PropTypes.array.isRequired,
    esUrl: PropTypes.string.isRequired,
    groups: PropTypes.array,
    version: PropTypes.string,
    shortenLabels: PropTypes.object
  };

  static defaultProps = {
    filter: {},
    shortenLabels: {}
  };

  state = {
    data: [],
    dataRaw: [], // for csv export
    loading: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading } = this.state;
    return (
      <LoadingWrapper loading={loading} spinSize="large" style={{ minHeight: 200 }}>
        {this._renderChart()}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    const { size } = this.props;
    const height = (500 * size) / 20;
    const VennDiagramChart = withChartConfig(makeWidthFlexible(VennChart), { data });

    return (
      <div>
        <VennDiagramChart data={data} height={height} smallLabelLineLength={20} />
      </div>
    );
  };

  _onColumnsChange = newSelectedColumns => this.setState({ selectedColumns: newSelectedColumns });

  _buildAggregations = pools => {
    const { version, shortenLabels } = this.props;
    // Get all the possible combinations for the pools
    const dataSets = new Array(1 << pools.length)
      .fill()
      .map((e1, i) => pools.filter((e2, j) => i & (1 << j)))
      .filter(a => a.length >= 1);

    let aggs = [];
    // For each dataset
    dataSets.forEach(dataset => {
      let mustAgg = [];
      let mustNotAgg = [];

      dataset.forEach(pool => {
        mustAgg.push({
          match: {
            [`${version}.pools`]: pool
          }
        });
      });

      const aggregation = {
        name: mustAgg
          .map(obj => {
            return shortenLabels[Object.values(obj.match)[0]] || Object.values(obj.match)[0];
          })
          .join("___"),
        filter: {
          bool: {
            must: mustAgg,
            must_not: mustNotAgg
          }
        }
      };
      // Add the aggregation
      aggs.push(aggregation);
    });
    return aggs;
  };

  _getData = props => {
    if (this._isMounted) this.setState({ loading: true });
    const { filter, esUrl, groups, version, defaultSets } = props;

    const searchGroup = groups ? groups : !defaultSets ? [] : defaultSets;

    const testFilter = {
      [`${version}.pools`]: searchGroup,
      ...filter
    };

    const apiCallPromise = getDocumentsWithAggregations(esUrl, testFilter, this._buildAggregations(searchGroup), version);
    apiCallPromise
      .then(res => {
        if (this._isMounted) {
          this.setState({
            data: this._reformatData(res),
            dataRaw: res,
            loading: false
          });
        }
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            data: [],
            dataRaw: [],
            loading: false
          });
      });
  };

  _reformatData = data => {
    let newData = [];

    Object.keys(data.aggregations).forEach(key => {
      // Check if this has 0 values
      if (data.aggregations[key].doc_count != 0) {
        newData.push({
          k: key,
          v: data.aggregations[key].doc_count
        });
      }
    });

    newData = newData.map(item => {
      return {
        k: item.k,
        v: item.v
      };
    });

    return newData;
  };
}

export default VennDiagram;
